export default __webpack_public_path__ + "static/media/light.d568a664.svg";